import { render, staticRenderFns } from "./FactorTypeAdjustmentModify.vue?vue&type=template&id=a1c32498&"
import script from "./FactorTypeAdjustmentModify.vue?vue&type=script&lang=js&"
export * from "./FactorTypeAdjustmentModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports